import { render, staticRenderFns } from "./CTPerfusion_v1.vue?vue&type=template&id=398d8cea&"
import script from "./CTPerfusion_v1.vue?vue&type=script&lang=ts&"
export * from "./CTPerfusion_v1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398d8cea')) {
      api.createRecord('398d8cea', component.options)
    } else {
      api.reload('398d8cea', component.options)
    }
    module.hot.accept("./CTPerfusion_v1.vue?vue&type=template&id=398d8cea&", function () {
      api.rerender('398d8cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/advanced/CTPerfusion_v1.vue"
export default component.exports